import { EUnitOfMeasure } from '../shared/enum';
import { TInputGeometry } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureLabel, EUnitOfMeasureMetricLabel } from './enum';

export const typeOfQuay: TInputGeometry = 'typeOfQuay';
export const quaySlope: TInputGeometry = 'quaySlope';
export const pileDiameter: TInputGeometry = 'pileDiameter';
export const distanceBetweenPileAxis: TInputGeometry = 'distanceBetweenPileAxis';
export const designWaterLevel: TInputGeometry = 'designWaterLevel';
export const designDredgingLevel: TInputGeometry = 'designDredgingLevel';
export const minimumUnderKeelClerance: TInputGeometry = 'minimumUnderKeelClerance';
export const distanceBetweenVesselAndQuay: TInputGeometry = 'distanceBetweenVesselAndQuay';
export const minimumWaterDepth: TInputGeometry = 'minimumWaterDepth';

export const geometryPhysicalData = {
    [typeOfQuay]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [quaySlope]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureLabel.deg,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureLabel.deg,
        },
    },
    [pileDiameter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [distanceBetweenPileAxis]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [designWaterLevel]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [designDredgingLevel]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [minimumUnderKeelClerance]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [distanceBetweenVesselAndQuay]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [minimumWaterDepth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
};
